module.exports = __webpack_public_path__ + "img/pic2.91262c34.png";